import { useState, useEffect } from 'react';
import { Form, Field } from 'react-final-form'
import { connect } from 'react-redux'
import { verifyOtp } from '../../actions';
export const SignUpPageTwo = ({ signUpSettings, setSignUpHeader, verifyOtp, signUpData }) => {
    // const [otpField, setOtpField] = useState("")
    // const [error, setError] = useState({error: false, message: ""})
    const [otpError, setOtpError] = useState({error: false, message: null})
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        setSignUpHeader({title: "Enter 6 Digit OTP", subtitle: 'Make sure both password are same'})

        return () => {
            setSignUpHeader({title: "", subtitle: ''})    
        }
    }, [setSignUpHeader])
    const onSubmit = (formValues) => {
        setLoading(true)
        
        verifyOtp(formValues, signUpData.number, signUpSettings, setOtpError, setLoading)
    }
    const goBack = () => {
        signUpSettings(state => {
            return {...state, otpSend: false, otp: null}
        })
    }
    const validateField = value => (value ? undefined : "Required")
    const validateOtp = value => {
        if (value){
            if (value.length === 6){
                if (value.match(/[a-zA-Z ]/)){
                    return "Invalid Otp"
                }
                else{
                    return undefined
                }
                
            }
            else{
                return "Invalid Otp"
            }
        }
        else{
            return "Required"
        }
    }
    const validateForm = (formValues) => {
        const { password1, password2} = formValues
        let error = {}
        if (password1 !== password2){
            error.password2 = "Both Password Dont Match"
        }
        return error
    }
    return (
        <Form
            validate={validateForm}
            subscription={{submitting: true, pristine: true}}
            onSubmit={onSubmit}
            initialValues={{entered_otp: signUpData.otp}}
            render={(formProps) => (
                <form className="ui large form" onSubmit={formProps.handleSubmit}>
                    {console.log(formProps)}
                    <Field name="entered_otp" validate={validateOtp}>
                        {({input, meta}) => (
                            <div className={`field ${meta.touched && meta.error && "error"}`}>
                            <label>OTP</label>
                            <input type="text" placeholder="Enter Six Digit OTP" {...input}/>
                        </div>
                        )}
                    </Field>
                    <Field name="password1" validate={validateField}>
                        {({input, meta}) => (
                            <div className={`field ${meta.touched && meta.error && "error"}`}>
                            <label>Password</label>
                            <input type="password" placeholder="Password" {...input}/>
                        </div>
                        )}
                    </Field>
                    <Field name="password2" validate={validateField}>
                        {({input, meta}) => (
                            <div className={`field ${meta.touched && meta.error && "error"}`}>
                            <label>Confirm Password</label>
                            <input type="password" placeholder="Confirm password" {...input}/>
                                {(meta.error && meta.touched && meta.error !== "Required") || otpError.error ? <div className="ui tiny message red">
                                {meta.error || otpError.message}
                                </div> : ""}
                        </div>
                        )}
                    </Field>
                    <div style={{textAlign: 'right'}}>
                        <button className="ui labeled icon button secondary" onClick={goBack}>
                            <i className="left arrow icon"></i>
                            Go Back
                        </button>
                        <button className={`ui positive right labeled icon button ${loading && "loading"}`} type="submit">
                            Submit
                            <i className="checkmark icon"></i>
                        </button>
                    </div>
                </form>
            )}
        />
    )
}

export default connect(null, { verifyOtp })(SignUpPageTwo)

/*

<form className="ui form">
    <div className="field">
        <label>OTP</label>
        <input type="text" value={otpField} onChange={(e) => setOtpField(e.target.value)} placeholder="Enter Six Digit OTP"/>
    </div>
    <div style={{textAlign: 'right'}}>
            <button className="ui labeled icon button secondary">
                <i className="left arrow icon"></i>
                Go Back
            </button>
            <button className="ui positive right labeled icon button" type="submit">
                Verify
                <i className="checkmark icon"></i>
            </button>
    </div>
    <div className={`ui message ${error.error ? "visible" : "hidden"}`}>
        <p>{error.message}</p>
    </div>
</form>

*/